import React, { useContext } from "react";
import AuthContext from "context/AuthContext";
import PANEL_TYPES from "core/panelTypes";
import HomeBridge from "./home/HomeBridge";
import HomeWaste from "./home/HomeWaste";

const HomeManager = () => {
    const { panel } = useContext(AuthContext);

    switch (panel.panel_type) {
        case PANEL_TYPES.BRIDGE:
            return <HomeBridge />;
        case PANEL_TYPES.WASTE:
        default:
            return <HomeWaste />;
    }
};

export default HomeManager;
